<template>
  <div class="transferencia-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información de la Autorización">
          <b-table 
              class="datos-objeto" 
              responsive="sm" 
              :items="autorizacionDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row v-if="transferido">
      <b-col cols="12" xl="12">  
        <b-card header="Información de la Transferencia">
          <b-table 
              class="datos-objeto" 
              responsive="sm" 
              :items="transferenciaDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'transferenciaDatos/getField',
  mutationType: 'transferenciaDatos/updateField',
});

export default {
  name: 'TransferenciaDatos',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      eventoId: 0,
      participanteId: 0,
      transferenciaId: 0,

      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
    }
  },
  computed: {
    ...mapFields([
      'autorizacionDatos',
      'transferenciaDatos',
    ]),
    transferido() {
      if (this.transferenciaDatos) {
        if (this.transferenciaDatos.length != 0) {
          return true;
        }
      }
      return false;
    }
  },
  created() {
    this.eventoId = this.$route.params.eventoId;
    this.participanteId = this.$route.params.participanteId;
    this.transferenciaId = this.$route.params.id;

    let params = {
      eventoId: this.eventoId,
      participanteId: this.participanteId,
      transferenciaId: this.transferenciaId
    }

    this.showSpinner();
    this.$store.dispatch('transferenciaDatos/getDatos', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style>
  .transferencia-datos .datos-objeto table td[aria-colindex="1"] {
    width: 20%;
  }
  .transferencia-datos .datos-objeto table td[aria-colindex="2"] {
    width: 80%;
  }
</style>